import { format } from 'date-fns';

/**
 * Formats a broadcast date into a string.
 *
 * @param broadcastDate - The broadcast date to format.
 * @return The formatted broadcast date as a string or null if the input is falsy.
 */
export function formatBroadcastDate(broadcastDate?: string | number | null): string | null {
	if (!broadcastDate) {
		return null;
	}

	const date = new Date(broadcastDate);

	const formattedBroadcastDate = format(date, "dd.MM.yyyy 'um' HH:mm 'Uhr'");

	return formattedBroadcastDate;
}
